import React, { useState } from 'react';
import { Box, Container, Text, VStack } from '@chakra-ui/react';
import { pageFadeIn } from '../../../utils/animations';
import NavBar from '../../../Components/Navbar/NavBar';
import Sales from "./SalesSBC";
import Reports from "./ReportsSBC";
import About from './AboutSBC';
import sbc_logo from '../../../Assets/sbc_logo.png';

function SBC() {
    const [selectedOption, setSelectedOption] = useState('Sales');
    
    const handleTabClick = (tab) => {
        setSelectedOption(tab);
    };

    const renderContent = () => {
        switch (selectedOption) {
            case 'Sales':
                return <Sales content="Sales SBC" color="red" />;
            case 'Reports':
                return <Reports content="Reports SBC" />;
            case 'About':
                return <About content="About SBC" />;
            default:
                return <Sales content="Sales SBC" color="red" />;
        }
    };

    return (
        <Box h="100vh" bg="gray.50" overflow="hidden">
            <NavBar 
                tabIndicatorColor="red.500" 
                logo={sbc_logo} 
                onTabClick={handleTabClick} 
            />
            
            <Box
            w="100%"
            h="calc(100vh - 60px)"
            overflow="hidden"
            bgColor="white"
            bgImage={`linear-gradient(rgba(255,255,255,0.88), rgba(255,255,255,0.88)), url(${sbc_logo})`}
            bgRepeat="no-repeat"
            bgSize="40% auto"
            bgPosition="right -80px"
            sx={{ animation: `${pageFadeIn} 0.55s ease both` }}
        >
                {renderContent()}
            </Box>
        </Box>
    );
}

export default SBC;
